export default __webpack_public_path__ + "6e21d689b5dd069616b0b273b56d55e5.png";